/* Alert Report */
export const RADAR_TOP_10_ALERTS = 'RADAR_TOP_10_ALERTS';
export const REPORT_ALERTS = 'REPORT_ALERTS';
export const GET_ADVANCED_REPORTS_LIST = 'GET_ADVANCED_REPORTS_LIST';
export const GET_ADVANCED_REPORTS_CONFIGURATION = 'GET_ADVANCED_REPORTS_CONFIGURATION';
export const UPDATE_DATE_TO = 'UPDATE_DATE_TO';
export const UPDATE_DATE_FROM = 'UPDATE_DATE_FROM';
export const ALERTS_BY_STATUS_IN_DATE_RANGE = 'ALERTS_BY_STATUS_IN_DATE_RANGE';
export const ALERTS_COUNT_BY_ENTITY = 'ALERTS_COUNT_BY_ENTITY';
export const FETCH_DATA_FLAG = 'FETCH_DATA_FLAG';
export const REPORT_ALERTS_LOAD_MORE = 'REPORT_ALERTS_LOAD_MORE';
export const START_SPINNER = 'START_SPINNER';
export const STOP_SPINNER = 'STOP_SPINNER';
export const SET_PRESERNT_DATA_STATUS = 'SET_PRESERNT_DATA_STATUS';
export const UPDATE_ALERT_ROWS = 'UPDATE_ALERT_ROWS';
/* Risk report */
